export default __webpack_public_path__ + "static/media/icon-voice-inbound.121f23fd.svg";